import { Module } from "@apis/index";
import ModuleDropdown from "@commons/modules/dropdown";
import Button from "@components/button";
import Column from "@components/column";
import Fields from "@components/fields";
import Row from "@components/row";
import Title from "@components/title";
import FieldWrapper from "@components/wrapper/field-wrapper";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FormSection, ImageUploadWrapper, UploadSection } from "./styles";

const ModuleForm = () => {
  const { state } = useLocation();
  const [initialState, setInitialState] = useState({
    name: "",
    type: "",
    icon: "",
    isModule: false,
    tagline: "",
    subtagline: "",
    illustration: "",
  });
  useEffect(() => {
    if (!!state || state?.id) {
      setInitialState({
        name: state.name || "",
        type: state.type || "",
        icon: state.icon || "",
        isModule: state.isModule || false,
        tagline: state.tagline || "",
        subtagline: state.subtagline || "",
        illustration: state.illustration || "",
      });
    }
  }, [state?.id]);
  const navigate = useNavigate();
  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      if (values.name) formData.append("name", values.name);
      if (values.type) formData.append("type", values.type);
      if (values.icon) {
        if (values.icon.rawFile) {
          formData.append("icon", values.icon.rawFile);
        } else if (typeof values.icon === "string") {
          // Keep existing icon if not changed
        }
      }
      if (values.tagline) formData.append("tagline", values.tagline);
      if (values.subtagline) formData.append("subtagline", values.subtagline);
      if (values.illustration) {
        if (values.illustration.rawFile) {
          formData.append("illustration", values.illustration.rawFile);
        } else if (typeof values.illustration === "string") {
          // Keep existing illustration if not changed
        }
      }
      formData.append("isModule", values.isModule);

      if (state?.id) {
        await Module.update({
          state: "modules",
          data: formData,
          id: state?.id,
        })
          .then(() => {})
          .catch(() => {});
      } else {
        await Module.create({
          state: "modules",
          data: formData,
        })
          .then(() => {})
          .catch(() => {});
      }
      navigate("/admin/modules/list");
    } catch (err) {
      console.error("Form submit error:", err);
    }
  };
  return (
    <>
      <Title textone={state?.id ? "Update" : "Create"} texttwo="Module" />
      <br />
      <Formik
        initialValues={initialState}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        <FieldWrapper>
          <Form>
            <Column>
              {" "}
              <Row styleRow="gap:52px">
                <FormSection>
                  <Column>
                    <Fields.Input
                      name="name"
                      placeholder="Ex: Grocery eCommerce Pharmacy etc."
                      label="Module Name"
                    />

                    <Fields.DropDown
                      name="type"
                      placeholder="---Select Module Type---"
                      label="Module Type"
                      options={[
                        { id: "food", name: "Food" },
                        { id: "grocery", name: "Grocery" },
                        { id: "store", name: "Store" },
                        { id: "pharma", name: "Pharma" },
                        { id: "dineout", name: "Dineout" },
                        { id: "anyservices", name: "Any services" },
                      ]}
                      titleAsKey="name"
                      valueAsKey="id"
                      styleOptionsWrapper="width:100%"
                      styleInput="width:97%"
                    />
                    <Fields.Input
                      name="tagline"
                      placeholder="Enter tagline"
                      label="Tagline"
                    />
                    <Fields.Input
                      name="subtagline"
                      placeholder="Enter sub tagline"
                      label="Sub Tagline"
                    />
                    <Fields.Switch label="is Module" name="isModule" />
                  </Column>
                </FormSection>
                <UploadSection>
                  <ImageUploadWrapper>
                    <label>Module Icon</label>
                    <Fields.Upload
                      name="icon"
                      useRawFile
                      height={180}
                      placeholder="upload icon"
                    />
                  </ImageUploadWrapper>

                  <ImageUploadWrapper>
                    <label>Illustration</label>
                    <Fields.Upload
                      name="illustration"
                      useRawFile
                      height={180}
                      placeholder="upload illustration"
                    />
                  </ImageUploadWrapper>
                </UploadSection>
              </Row>
              <Button title="Save" type="submit" justify="end" />
            </Column>
          </Form>
        </FieldWrapper>
      </Formik>
    </>
  );
};

export default ModuleForm;
